import { ProductsExcelUploadResponseProductDtoStatusEnum, ProductsResponseBodyProductDto } from '../api/products';
import { MainCategoryItem, PRODUCT_DISCOUNT_TYPE_V2, PRODUCT_STATUS_V2 } from './common';
import { DateRageType } from '../common/date';
import { BRAND_STATUS_V2 } from '../brand/common';
import { GetProductListRequest } from '../../lib/api/product/type';
import { BrandsFindResponseBodyBrandDtoStatusEnum } from '../api/brands';

export class ProductItemV2 {
  id: number;
  imageUrl: string;
  name: string;
  status: PRODUCT_STATUS_V2;
  originPrice: number;
  salesPrice: number;
  discountType: PRODUCT_DISCOUNT_TYPE_V2 | null;
  discountPrice?: number;
  discountRate?: number;
  discountPeriod: DateRageType;
  brandId: number;
  brandName: string;
  brandStatus: BRAND_STATUS_V2 | null;
  createDate: string;
  updateDate: string;
  mainCategoryList: MainCategoryItem[];

  constructor(product: ProductsResponseBodyProductDto) {
    this.id = product.id;
    this.imageUrl = product.mainImageUrl;
    this.name = product.name;
    this.status = product.status;
    this.originPrice = product.originPrice;
    this.salesPrice = product.salesPrice;
    this.discountType = product.discountType;
    this.discountPrice = product.discountPrice;
    this.discountRate = product.discountRate;
    this.discountPeriod = {
      startDate: product.discountStartDate || null,
      endDate: product.discountEndDate || null,
    };
    this.brandId = product.brand.id;
    this.brandName = product.brand.name;
    this.brandStatus = product.brand.status;
    this.createDate = product.createDate;
    this.updateDate = product.updateDate;
    this.mainCategoryList = product.mainCategories;
  }
}

export type ProductListRequest = {
  id?: number;
  name?: string;
  status?: PRODUCT_STATUS_V2 | null;
  brandName?: string;
  brandId?: number;
  brandStatus?: BRAND_STATUS_V2 | null;
  mainCategoryList?: number | null;
  createStartDate?: string;
  createEndDate?: string;
  updateStartDate?: string;
  updateEndDate?: string;
  page?: number;
  pageSize?: number;
  sort?: string[];
};

export class ProductListRequestOptionV2 implements GetProductListRequest {
  id?: number;
  name?: string;
  status?: ProductsExcelUploadResponseProductDtoStatusEnum | null;
  categoryId?: number | null;
  brandId?: number;
  brandName?: string;
  brandStatus?: BrandsFindResponseBodyBrandDtoStatusEnum | null;
  createStartDate?: string;
  createEndDate?: string;
  updateStartDate?: string;
  updateEndDate?: string;
  page?: number;
  pageSize?: number;
  sort?: string[];

  constructor(option: ProductListRequest) {
    this.id = option.id;
    this.name = option.name;
    this.status = option.status;
    this.categoryId = option.mainCategoryList;
    this.brandId = option.brandId;
    this.brandName = option.brandName;
    this.brandStatus = option.brandStatus;
    this.createStartDate = option.createStartDate;
    this.createEndDate = option.createEndDate;
    this.updateStartDate = option.updateStartDate;
    this.updateEndDate = option.updateEndDate;
    this.page = option.page;
    this.pageSize = option.pageSize;
    this.sort = option.sort;
  }
}
